import { TimeInput } from "@mantine/dates";
export const timeInputProps = TimeInput.extend({});
